import api from '../../api';
import useHttpData from '../useHttpData';

// Fetches the retailer-scoped gateway health KPIs for the [from, to] window: fleet
// health-bucket counts and the most frequent alarm codes. Both endpoints are scoped
// to the authenticated retailer server-side.
const useHttpGetGatewayKpis = (from, to, alarmLimit = 10) => {
    const { data, isReady, error } = useHttpData(async () => {
        const [overviewRes, alarmRes] = await Promise.all([
            api.get_gateway_fleet_overview(from, to),
            api.get_gateway_alarm_frequency(from, to, alarmLimit),
        ]);
        return { overview: overviewRes.data || null, alarms: alarmRes.data?.alarms || [] };
    }, [from, to, alarmLimit]);

    return { overview: data?.overview ?? null, alarms: data?.alarms ?? [], isReady, error };
};

export default useHttpGetGatewayKpis;
